import { render } from "./TrashCanSvg.vue?vue&type=template&id=4a5e00b5"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__